<template>
  <div class="modal"
       id="bike_Testing"
       tabindex="-1"
       role="dialog"
       aria-hidden="true">
    <div class="modal-dialog modal-lg"
         role="document">
      <div class="modal-content">
        <div class="modal-body">
          <template v-if="itemId === 'diagnosisHmiDisplay'">
            <diagnosis-hmi-display-step
              :btnHmi="btnHmi"
              :modalOpen="open"
              :title="title"
              :bikeVal="bikeVal"
              :bikeErrorCode="bikeErrorCode"
              :content="content"
              :btn="btn"
              :seconds="seconds"
              @specialHmi="funcHandleSpecialHmi"
              @keyUpEvent="funcHandleUp"
              @keyDownEvent="funcHandleDown"
              @keyPowerEvent="funcHandlePower">
            </diagnosis-hmi-display-step>
          </template>
          <template v-if="itemId === 'diagnosisHmiConsole'">
            <diagnosis-hmi-console-step
              :btnHmi="btnHmi"
              :modalOpen="open"
              :title="title"
              :bikeVal="bikeVal"
              :bikeErrorCode="bikeErrorCode"
              :content="content"
              :btn="btn"
              :seconds="seconds"
              @specialHmi="funcHandleSpecialHmi"
              @keyUpEvent="funcHandleUp"
              @keyDownEvent="funcHandleDown"
              @keyPowerEvent="funcHandlePower">
            </diagnosis-hmi-console-step>
          </template>
          <template v-if="itemId === 'diagnosisHmiDisplayConsole'">
            <diagnosis-hmi-step
              :btnHmi="btnHmi"
              :modalOpen="open"
              :title="title"
              :bikeVal="bikeVal"
              :bikeErrorCode="bikeErrorCode"
              :content="content"
              :btn="btn"
              :seconds="seconds"
              @specialHmi="funcHandleSpecialHmi"
              @keyUpEvent="funcHandleUp"
              @keyDownEvent="funcHandleDown"
              @keyPowerEvent="funcHandlePower">
            </diagnosis-hmi-step>
          </template>
          <template v-if="itemId === 'diagnosisDriver' || itemId === 'diagnosisMotor' || itemId === 'diagnosisBattery'">
            <diagnosis-motor-battery-step
              :modalOpen="open"
              :title="title"
              :itemId="itemId"
              :bikeVal="bikeVal"
              :bikeStatus="bikeStatus"
              :bikeErrorCode="bikeErrorCode"
              :seconds="seconds"
              :content="content"
              :btn="btn"
              @keyDownEvent="funcHandleDown"
              @keyPowerEvent="funcHandlePower">
            </diagnosis-motor-battery-step>
          </template>
          <template v-if="diagnosisItem === 'sensor'">
            <diagnosis-sensor-step
              :modalOpen="open"
              :title="title"
              :itemId="itemId"
              :bikeVal="bikeVal"
              :bikeStatus="bikeStatus"
              :bikeErrorCode="bikeErrorCode"
              :content="content"
              :btn="btn"
              :seconds="seconds"
              :counter="counter"
              @keyDownEvent="funcHandleDown"
              @keyPowerEvent="funcHandlePower">
            </diagnosis-sensor-step>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DiagnosisSensorStep from './DiagnosisSensorStep';
import DiagnosisMotorBatteryStep from './DiagnosisMotorBatteryStep';
import DiagnosisHmiStep from './DiagnosisHmiStep';
import DiagnosisHmiDisplayStep from './DiagnosisHmiDisplayStep';
import DiagnosisHmiConsoleStep from './DiagnosisHmiConsoleStep';

export default {
  name: 'DiagnosisModal',
  props: [
    'open',
    'title',
    'itemId',
    'btn',
    'bikeVal',
    'content',
    'seconds',
    'counter',
    'bikeStatus',
    'bikeErrorCode',
    'btnHmi'
  ],
  components: {
    DiagnosisSensorStep,
    DiagnosisMotorBatteryStep,
    DiagnosisHmiStep,
    DiagnosisHmiDisplayStep,
    DiagnosisHmiConsoleStep
  },
  watch: {
    open (val) {
      if (val) { $('#bike_Testing').modal(); }
    }
  },
  computed: {
    diagnosisItem () {
      return this.$route.meta.id;
    },
    block () {
      return this.open ? 'block' : 'none';
    }
  },
  methods: {
    funcHandleUp (key) {
      this.$emit('keyUpEvent', key);
    },
    funcHandleDown (key) {
      this.$emit('keyDownEvent', key);
    },
    funcHandlePower (power) {
      this.$emit('keyPowerEvent', power);
    },
    funcHandleSpecialHmi (obj) {
      this.$emit('specialHmi', obj);
    }
  }
};
</script>
<style lang="scss">
.step-bar-none-finish::after {
  background: #1e1e1a !important;
}

.isHidePowerText {
  color: #1b1c19 !important;
}
#bike_Testing {
  .modal-open {
    overflow: hidden;

    .modal {
      overflow-x: hidden;
      overflow-y: auto;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
  }

  .modal-dialog {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin: 0;
  }

  .modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll;
  }

  .modal-content {
    position: absolute;
    background-color: $black;
    background-clip: padding-box;
    border-radius: 2px;
    outline: 0;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    left: 50%;
    top: 50%;
    right: auto;
    min-height: 300px;
    max-height: 84vh;
    width: 90%;
    max-width: 600px;
    transform: translate(-50%, -50%);
  }

  .modal-body {
    position: relative;
    flex-grow: 100;
    padding: 15px;
    overflow: auto;

    .container {
      max-width: 500px;
      margin: 0 auto;
    }
  }

  .modal-header {
    padding: 0;
    border-bottom: 0;
    line-height: 15px;

    &::after {
      display: block;
      content: "";
      clear: both;
    }

    .close {
      padding: 15px;
      line-height: inherit;
    }
  }

  .modal-footer {
    padding: 7.5px;
    border-top: 0;

    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  .modal-lg {
    .modal-body {
      // max-height: calc(84vh - 100px);

      .container {
        width: 100%;
        max-width: 1200px;
      }
    }

    .modal-content {
      min-height: 84vh;
      height: 84vh;
      max-height: 84vh;
      width: 90%;
      max-width: 90%;
    }
  }

  .modal-sm {
    .modal-body {
      padding: 45px;
    }

    .modal-content {
      min-height: 200px;
      max-height: 84vh;
      max-width: 400px;
    }
  }
}
</style>
